import { Link } from 'react-router-dom';
import { useLang } from '../context/LangContext';

const Footer = () => {
  const { t, isRtl, lang, toggleLang } = useLang();

  const navLinks = [
    ['/services', t.nav.services],
    ['/why-us',   t.nav.whyUs],
    ['/contact',  t.nav.contact],
  ];

  const legalLinks = [
    [isRtl ? 'مركز المساعدة'   : 'Help Center',    '#'],
    [isRtl ? 'سياسة الخصوصية' : 'Privacy Policy', '#'],
    [isRtl ? 'الشروط والأحكام' : 'Terms',          '#'],
  ];

  const socials = [
    {
      label: 'Facebook', href: 'https://www.facebook.com/profile.php?id=61587278585452',
      icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M22 12a10 10 0 10-11.5 9.87v-6.99h-2.7V12h2.7V9.8c0-2.66 1.58-4.13 4-4.13 1.16 0 2.38.2 2.38.2v2.62h-1.34c-1.32 0-1.73.82-1.73 1.66V12h2.94l-.47 2.88h-2.47v6.99A10 10 0 0022 12z"/></svg>,
    },
    {
      label: 'LinkedIn', href: 'https://www.linkedin.com/company/zeiia',
      icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>,
    },
    {
      label: 'TikTok', href: 'https://www.tiktok.com/@zeiia98?_r=1&_t=ZS-94widaPqSA8',
      icon: <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M12.75 2h3.5a5.75 5.75 0 005.75 5.75v3.5a9.25 9.25 0 01-5.75-1.96v6.96a6.5 6.5 0 11-6.5-6.5c.27 0 .53.02.79.06v3.58a3 3 0 103 3V2z"/></svg>,
    },
  ];

  return (
    <footer style={{
      position: 'relative', overflow: 'hidden',
      background: '#fdfdfc', borderTop: '1px solid #e7e8ec',
    }}>

      {/* CTA — كارت غامق، بس مبني كـ split (نص على الشمال، زرار
          على اليمين) مش استاك متمركز. ده شكل "دعوة عمل" في تقارير
          الشركات الكبيرة، مختلف عن أي تكوين centered-stack */}
      <div style={{ maxWidth: 1240, margin: '0 auto', padding: '48px 24px 0' }}>
        <div className="cta-card" style={{ position: 'relative', borderRadius: 20, overflow: 'hidden' }}>

          {/* اللوحة الغامقة — بتاخد كل مساحة الكارت وبتفضل خلفية */}
          <div className="cta-navy" style={{
            background: 'linear-gradient(135deg, #0a0e1c 0%, #0d1326 100%)',
            display: 'flex', alignItems: 'center',
            padding: '52px 44px',
            paddingInlineEnd: 'clamp(180px, 30%, 320px)',
          }}>
            <h2 style={{
              fontFamily: "'Cairo', sans-serif", fontWeight: 700, color: '#fff',
              fontSize: 'clamp(21px, 2.5vw, 30px)', margin: 0, lineHeight: 1.5,
            }}>
              {isRtl ? 'جاهز نبني مشروعك القادم؟' : "Ready to build what's next?"}
            </h2>
          </div>

          {/* اللوحة الذهبية — قطعة لون كاملة بحافة مايلة بتقطع في
              الغامق، مش مجرد زرار طايف فوق خلفية واحدة مسطحة */}
          <div className="cta-gold" style={{
            position: 'absolute', insetBlock: 0, [isRtl ? 'left' : 'right']: 0,
            width: '34%', background: '#C9A96E', '--cta-cut': '14%',
            display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 20px',
            clipPath: isRtl
              ? 'polygon(0 0, 100% 0, 100% 100%, var(--cta-cut) 100%)'
              : 'polygon(var(--cta-cut) 0, 100% 0, 100% 100%, 0 100%)',
          }}>
            <Link to="/contact" className="cta-pill" style={{
              display: 'inline-flex', alignItems: 'center', gap: 9,
              background: '#0a0e1c', color: '#fff', borderRadius: 8,
              padding: '13px 20px', textDecoration: 'none',
              fontWeight: 700, fontSize: 13.5, whiteSpace: 'nowrap',
              transition: 'background .2s',
            }}>
              <span className="cta-label-full">{isRtl ? 'ابدأ المحادثة' : 'Start the conversation'}</span>
              <span className="cta-label-short">{isRtl ? 'يلا نبدأ' : 'Get started'}</span>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"
                style={{ transform: isRtl ? 'rotate(180deg)' : 'none', flexShrink: 0 }}>
                <path d="M5 12h14M13 6l6 6-6 6" />
              </svg>
            </Link>
          </div>
        </div>
      </div>

      {/* المحتوى — استاك واحد متمركز: اللوجو، الوصف، السوشيال،
          وبعدين كل الروابط في سطر واحد تحت بعض، زي المرجع بالظبط */}
      <div style={{ maxWidth: 720, margin: '0 auto', padding: '56px 24px 0', textAlign: 'center' }}>

        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          fontFamily: "'Cairo', sans-serif", fontSize: 22, fontWeight: 800,
          letterSpacing: '-0.01em', marginBottom: 16,
        }}>
          {isRtl ? (
            <>
              <span style={{ width: 5, height: 5, borderRadius: '50%', background: '#C9A96E' }} />
              <span style={{ color: '#0a0e1c' }}>{t.companyName}</span>
            </>
          ) : (
            <span style={{ color: '#0a0e1c' }}>zeii<span style={{ color: '#C9A96E' }}>a</span></span>
          )}
        </div>

        <p style={{ fontSize: 14.5, lineHeight: 1.9, color: '#6b7280', margin: '0 0 32px' }}>
          {t.footer.desc}
        </p>

        <div style={{ display: 'flex', justifyContent: 'center', gap: 10, marginBottom: 32 }}>
          {socials.map(({ label, icon, href }) => (
            <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} className="social-sq"
              style={{
                width: 34, height: 34, borderRadius: 9, background: '#0a0e1c', color: '#fff',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                textDecoration: 'none', transition: 'background .2s',
              }}
            >
              {icon}
            </a>
          ))}
        </div>

        <nav style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', columnGap: 28, rowGap: 12 }}>
          {navLinks.map(([to, label]) => (
            <Link key={to} to={to} className="footer-nav-link" style={{ color: '#3d4451', textDecoration: 'none', fontSize: 14, fontWeight: 500 }}>
              {label}
            </Link>
          ))}
          {legalLinks.map(([label, href]) => (
            <a key={label} href={href} className="footer-nav-link" style={{ color: '#3d4451', textDecoration: 'none', fontSize: 14, fontWeight: 500 }}>
              {label}
            </a>
          ))}
        </nav>
      </div>

      {/* Bottom bar */}
      <div style={{ maxWidth: 1240, margin: '32px auto 0', padding: '18px 24px', borderTop: '1px solid #edeef2' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10, fontSize: 12.5 }}>
          <p style={{ color: '#9a9fab', margin: 0 }}>{t.footer.rights}</p>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span onClick={lang !== 'en' ? toggleLang : undefined} role="button" tabIndex={0}
              onKeyDown={e => { if ((e.key === 'Enter' || e.key === ' ') && lang !== 'en') toggleLang(); }}
              style={{ cursor: lang === 'en' ? 'default' : 'pointer', color: lang === 'en' ? '#0a0e1c' : '#9a9fab', fontWeight: 600 }}
            >English</span>
            <span style={{ color: '#c8cbd3' }}>/</span>
            <span onClick={lang !== 'ar' ? toggleLang : undefined} role="button" tabIndex={0}
              onKeyDown={e => { if ((e.key === 'Enter' || e.key === ' ') && lang !== 'ar') toggleLang(); }}
              style={{ cursor: lang === 'ar' ? 'default' : 'pointer', color: lang === 'ar' ? '#0a0e1c' : '#9a9fab', fontWeight: 600 }}
            >عربي</span>
          </div>
        </div>
      </div>

      {/* توقيع تايبوجرافي ضخم برضو، لكن outline مش solid ومنحاز لحافة
          واحدة (مش متمركز) — نفس مبدأ "الاسم اللي بيتقطع" لكن تنفيذ
          مختلف يخص زيا: حروف مفرّغة بلون ذهبي خفيف، مش رمادي solid */}
      <div aria-hidden="true" style={{
        position: 'relative', height: 'clamp(70px, 11vw, 140px)',
        marginTop: 36, overflow: 'hidden', pointerEvents: 'none',
      }}>
        <div style={{
          position: 'absolute', [isRtl ? 'right' : 'left']: '-1.5vw', bottom: '-0.28em',
          fontFamily: "'Cairo', sans-serif", fontWeight: 800,
          fontSize: 'clamp(80px, 15vw, 200px)', lineHeight: 1,
          whiteSpace: 'nowrap', letterSpacing: '-0.02em',
          color: 'transparent', WebkitTextStroke: '1.5px rgba(201,169,110,0.35)',
        }}>
          zeiia
        </div>
      </div>

      <style>{`
        .cta-pill:hover { background: #000 !important; }
        .social-sq:hover { background: #C9A96E !important; }
        .footer-nav-link:hover { color: #C9A96E !important; }
        footer a:focus-visible, footer span[role="button"]:focus-visible {
          outline: 2px solid #C9A96E; outline-offset: 2px; border-radius: 3px;
        }
        .cta-label-short { display: none; }
        @media (prefers-reduced-motion: reduce) {
          footer * { transition: none !important; }
        }
        @media (max-width: 720px) {
          .footer-columns { flex-direction: column; align-items: center !important; gap: 40px !important; text-align: center; }
          .footer-columns > div { max-width: 280px !important; align-items: center !important; }
          .cta-card, .cta-navy, .cta-gold { box-sizing: border-box; }
          .cta-navy { padding: 26px 20px !important; padding-inline-end: clamp(130px, 38%, 190px) !important; }
          .cta-navy h2 { font-size: 15.5px !important; line-height: 1.55 !important; }
          .cta-gold { width: 38% !important; padding: 0 10px !important; --cta-cut: 10% !important; }
          .cta-gold .cta-pill { padding: 9px 14px !important; font-size: 12px !important; gap: 6px !important; }
          .cta-gold .cta-pill svg { width: 12px !important; height: 12px !important; }
        }
        @media (max-width: 480px) {
          .cta-label-full { display: none; }
          .cta-label-short { display: inline; }
        }
        @media (max-width: 430px) {
          .cta-navy { padding: 24px 18px !important; padding-inline-end: clamp(112px, 40%, 145px) !important; }
          .cta-navy h2 { font-size: 13.5px !important; line-height: 1.55 !important; }
          .cta-gold { width: 40% !important; padding: 0 8px !important; --cta-cut: 8% !important; }
          .cta-gold .cta-pill { padding: 8px 11px !important; font-size: 11px !important; gap: 5px !important; }
          .cta-gold .cta-pill svg { width: 11px !important; height: 11px !important; }
        }
        @media (max-width: 350px) {
          .cta-navy h2 { font-size: 12.5px !important; }
          .cta-gold { width: 44% !important; }
          .cta-gold .cta-pill { padding: 8px 9px !important; font-size: 10px !important; }
        }
      `}</style>
    </footer>
  );
};

export default Footer;